import http from '../axios.ts'


const api = {
    /**
     * 发送邮箱验证码
     * @param params  $toEmail：收件箱地址，$type：login、register、seekpwd、updatePwd
     */
    getPriceByGoodsIdAndUserId(params:Object) {
        const res = http.post('/userSkuPrice/getPriceByGoodsIdAndUserId', params);
        return res;
    },

    /**
     * 获取所有SKU 列表
     */
    addOrUpdate(params:Object) {
        const res = http.post('/userSkuPrice/addOrUpdate', params);
        return res;
    }
}

export default api
